import React, { useState } from "react";

const GHOST_IMAGE = "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/dwuy865y_image.png";

const GhostAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "ghost", text: "Ghost here. Powered by Prestigious Companies. What do you need?" },
  ]);
  const [input, setInput] = useState("");

  const replies = [
    "Adris Davis has over 20 years in high-pressure sales environments. Director of Sales across Wyndham, Diamond Resorts, and Hilton Grand Vacations following the $1.4 billion acquisition. Check the About page for the full breakdown.",
    "Five published books covering sales strategy, credit mastery, and entrepreneurship. All available on Amazon. Hit the Books page for direct links.",
    "Team Hustle is production-driven mentorship. Six-figure and seven-figure producers developed through closing mastery, buyer psychology, and daily discipline. Not theory. Results. Visit the Initiatives dropdown.",
    "Night Owl Entrepreneurs is a collective for builders who operate when everyone else is asleep. Execution over talk. Accountability at a high level. Apply through Initiatives.",
    "Social Media Amber Alert was created over six years ago to bring visibility to missing persons cases when traditional systems fall short. Visibility saves lives. Details under Initiatives.",
    "Adris Davis Realty applies the same negotiation-driven mindset from sales leadership to real estate. Strategy, positioning, and execution. Visit the Realty page.",
    "For speaking engagements, collaborations, or direct inquiries, use the Contact page. No fluff. State what you need.",
    "Cars for Families Initiative. Over 20 vehicles given away since 2020 to individuals and families facing hardship. Not for recognition. For impact.",
    "The approach is simple. Equip people with tools, knowledge, and confidence to operate at an elite level in business and in life. Everything on this site reflects that mission.",
  ];

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    const reply = replies[Math.floor(Math.random() * replies.length)];
    setMessages((prev) => [...prev, { from: "user", text: input.trim() }, { from: "ghost", text: reply }]);
    setInput("");
  };

  return (
    <>
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-80 sm:w-96 rounded-lg shadow-2xl overflow-hidden" style={{ backgroundColor: "#0B1628", border: "1px solid rgba(255,255,255,0.06)" }}>
          {/* Header */}
          <div className="flex items-center gap-3 px-4 py-3" style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
            <img src={GHOST_IMAGE} alt="Ghost" className="w-8 h-8 rounded-full object-cover" />
            <div className="flex-1">
              <p className="text-white text-sm font-semibold tracking-wide">Ghost&trade;</p>
              <p className="text-[10px]" style={{ color: "rgba(255,255,255,0.3)" }}>Powered by Prestigious Companies</p>
            </div>
            <button onClick={() => setIsOpen(false)} className="text-white/20 hover:text-white/50 text-lg transition-colors">&times;</button>
          </div>

          {/* Messages */}
          <div className="h-56 overflow-y-auto px-4 py-3 space-y-3">
            {messages.map((msg, i) => (
              <div key={i} className={`flex ${msg.from === "user" ? "justify-end" : "justify-start"}`}>
                <div
                  className="max-w-[85%] px-3 py-2 rounded text-xs leading-relaxed"
                  style={{
                    backgroundColor: msg.from === "user" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.02)",
                    color: msg.from === "user" ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.5)",
                  }}
                >
                  {msg.text}
                </div>
              </div>
            ))}
          </div>

          {/* Input */}
          <form onSubmit={handleSend} className="flex gap-2 px-4 py-3" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask Ghost..."
              className="flex-1 px-3 py-2 rounded text-xs text-white placeholder-white/20 focus:outline-none"
              style={{ backgroundColor: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}
            />
            <button
              type="submit"
              className="px-4 py-2 rounded text-xs font-medium tracking-wide transition-colors"
              style={{ backgroundColor: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.5)" }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = "rgba(255,255,255,0.1)"; e.target.style.color = "rgba(255,255,255,0.8)"; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = "rgba(255,255,255,0.06)"; e.target.style.color = "rgba(255,255,255,0.5)"; }}
            >
              Send
            </button>
          </form>
        </div>
      )}

      {/* Floating button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-lg overflow-hidden transition-transform duration-300 hover:scale-110"
        style={{ backgroundColor: "#0B1628", border: "1px solid rgba(255,255,255,0.08)" }}
        aria-label="Open Ghost Assistant"
      >
        <img src={GHOST_IMAGE} alt="Ghost" className="w-full h-full object-cover" />
      </button>
    </>
  );
};

export default GhostAssistant;
